import React, { useState } from "react";

const TwoColumnLayout = ({ settings }) => {
    const { blocks, url, section } = settings;
    const [selectedTags, setSelectedTags]: any = useState([]);
    const show_all = false;

    const handleTagClick = (title, blockUrl, blockId) => {
        if (section.navigation_type === 'url' && blockUrl) {
            // Navigate to URL
            window.location.href = blockUrl;
        } else if (section.navigation_type === 'id' && blockId) {
            // Scroll to element with ID
            const element = document.getElementById(blockId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        } else {
            // Handle filtering
            if (selectedTags.includes(title)) {
                setSelectedTags(selectedTags.filter((tag) => tag !== title));
            } else {
                setSelectedTags([title]);
            }
        }
    };

    return (
        <div x-data="blogfilters" className="flex justify-between">
            <div className="flex">
                <h2>Blog</h2>
            </div>
            <div className="blog-filters">
                <ul className="blog-filters__list">
                    {show_all && (
                        <li
                            className={`blog-filters__button button button-tertiary ${
                                selectedTags.length === 0 && "selected"
                            }`}
                            onClick={() => {
                                if (section.navigation_type === 'url' && url) {
                                    window.location.href = url;
                                } else {
                                    setSelectedTags([]);
                                }
                            }}
                        >
                            <div data-id={url}>All</div>
                        </li>
                    )}
                    {blocks.map((block, index) => (
                        <li
                            key={index}
                            className={`blog-filters__button button button-tertiary ${
                                selectedTags.includes(block.settings.title) && "selected"
                            }`}
                            onClick={() =>
                                handleTagClick(block.settings.title, block.settings.url, block.settings.id)
                            }
                        >
                            <div data-id={block.settings.url}>
                                {block.settings.title}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TwoColumnLayout;
